import { ProjectVirtualGraphsToCreate } from 'src/containers/ProjectResourceDialog/ProjectVirtualGraphCreationPanel/types';

export const getTablesFromVgsToCreate = (
  virtualGraphsToCreate: ProjectVirtualGraphsToCreate
) => {
  return Object.values(virtualGraphsToCreate).filter(
    (virtualGraphToCreate) => typeof virtualGraphToCreate.from === 'object'
  );
};
